/**
 * Pure helpers for app access (CASL + CATEGORY_ADMIN + accessibleApps).
 */

import type { AppAbility } from '../../types/casl';

/** Mirrors permissionService.ApplicationType — kept local to avoid pulling keycloak into Jest. */
export type AppAccessId = 'regal_main' | 'cybersweep' | 'credit_block' | 'credit_management';

export const FULL_APP_ACCESS: AppAccessId[] = [
  'regal_main',
  'cybersweep',
  'credit_block',
  'credit_management',
];

export function computeCanAccessApp(
  app: AppAccessId,
  opts: {
    accessibleApps: AppAccessId[] | undefined;
    categoryAdmin: boolean | undefined;
    ability: AppAbility;
  }
): boolean {
  if (opts.categoryAdmin) return true;
  if (opts.accessibleApps?.includes(app)) return true;
  return opts.ability.can('access', app);
}

export function mergeAccessibleAppsList(
  accessibleApps: AppAccessId[] | undefined,
  categoryAdmin: boolean | undefined
): AppAccessId[] {
  if (categoryAdmin) return [...FULL_APP_ACCESS];
  return accessibleApps?.length ? accessibleApps : ['regal_main'];
}
